// 事務所の問い合わせ先（配送アプリの設定に出す）。Firestore の officeContacts に置き、システム管理者だけが直す
import { useEffect, useState, type FormEvent } from 'react';
import { doc, getDoc, setDoc } from 'firebase/firestore';
import { can, type OfficeContactDoc } from '@torapon/shared';
import { fsdb } from '../lib/firebase';
import { useMe } from '../lib/me';
import { useStepUp } from './StepUp';
import { useToast } from './ui';

const PHONE = /^[0-9+][0-9-]{5,19}$/;

export function OfficeContactPanel() {
  const me = useMe();
  const toast = useToast();
  const { ensureRecent } = useStepUp();
  const [f, setF] = useState({ name: '', phone: '', hours: '' });
  const [loaded, setLoaded] = useState(false);
  const [err, setErr] = useState('');
  const officeId = me?.officeId;
  useEffect(() => {
    if (!officeId) return;
    getDoc(doc(fsdb(), 'officeContacts', officeId)).then((s) => {
      const d = s.data() as OfficeContactDoc | undefined;
      if (d) setF({ name: d.name, phone: d.phone, hours: d.hours });
    }).catch(() => {}).finally(() => setLoaded(true));
  }, [officeId]);
  if (!me || !officeId) return null;
  const canEdit = can(me.role, 'manageStaff');
  const save = async (e: FormEvent) => {
    e.preventDefault(); setErr('');
    const v = { name: f.name.trim(), phone: f.phone.trim(), hours: f.hours.trim() };
    if (!v.name || v.name.length > 40) { setErr('呼び名を 40 文字までで入れてください'); return; }
    if (!PHONE.test(v.phone)) { setErr('電話番号は数字とハイフンで入れてください（例：011-000-0000）'); return; }
    if (v.hours.length > 60) { setErr('受付時間は 60 文字までです'); return; }
    if (!(await ensureRecent('問い合わせ先の変更'))) return;
    try { await setDoc(doc(fsdb(), 'officeContacts', officeId), { officeId, ...v } satisfies OfficeContactDoc); toast('問い合わせ先を保存しました'); }
    catch { setErr('保存できませんでした'); }
  };
  return (
    <section className="panel" aria-label="事務所の問い合わせ先">
      <div style={{ padding: '14px 16px 0' }}><b>事務所の問い合わせ先</b><br /><small className="muted">配送アプリの「メニュー」に出ます。ドライバーが困ったときにかける電話です</small></div>
      <form onSubmit={save} style={{ padding: 16, display: 'grid', gap: 8, gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', alignItems: 'end' }}>
        <div className="field"><label htmlFor="oc-name">呼び名</label><input id="oc-name" value={f.name} disabled={!canEdit || !loaded} placeholder="例：札幌本社 配車係" onChange={(e) => setF({ ...f, name: e.target.value })} /></div>
        <div className="field"><label htmlFor="oc-phone">電話番号</label><input id="oc-phone" value={f.phone} disabled={!canEdit || !loaded} inputMode="tel" placeholder="例：011-000-0000" onChange={(e) => setF({ ...f, phone: e.target.value })} /></div>
        <div className="field"><label htmlFor="oc-hours">受付時間（任意）</label><input id="oc-hours" value={f.hours} disabled={!canEdit || !loaded} placeholder="例：平日 8:00〜18:00" onChange={(e) => setF({ ...f, hours: e.target.value })} /></div>
        {canEdit ? <button className="btn pri" style={{ justifySelf: 'start' }}>保存する</button> : <small className="muted">直せるのはシステム管理者だけです</small>}
        {err && <p className="err" role="alert" style={{ gridColumn: '1 / -1' }}>{err}</p>}
      </form>
    </section>
  );
}
